import React from 'react';

import './footer.scss';

function Footer() {
  return (
    <footer className="footer">
      <a href="https://www.ux-republic.com/" target="_blank" rel="noreferrer noopener">
        <img className="footer-logo" src="assets/logo.png" alt="Logo UX-Republic" />
      </a>
      <span>
        by
        <a className="footer-author" href="https://fr.linkedin.com/in/nlsbienaime" target="_blank" rel="noreferrer noopener">
          Nicolas Bienaime
        </a>
      </span>
    </footer>
  );
}

export default Footer;
